import { Action } from 'types';

export interface ApplicationUIReducer {
  businessOnboardingPopUpIsActive: boolean;
  popUpIsActive: boolean;
  notificationBarIsActive: boolean | null;
  notificationBarHeight: number;
}

const initialState: ApplicationUIReducer = {
  businessOnboardingPopUpIsActive: false,
  popUpIsActive: false,
  notificationBarIsActive: null,
  notificationBarHeight: 0,
};

export default (
  state: ApplicationUIReducer = initialState,
  action: Action
): ApplicationUIReducer => {
  switch (action.type) {
    case 'OPEN_POP_UP':
      return {
        ...state,
        popUpIsActive: true,
      };
    case 'CLOSE_POP_UP':
      return {
        ...state,
        popUpIsActive: false,
      };
    case 'OPEN_BUSINESS_ONBOARDING_POP_UP':
      return {
        ...state,
        businessOnboardingPopUpIsActive: true,
      };
    case 'CLOSE_BUSINESS_ONBOARDING_POP_UP':
      return {
        ...state,
        businessOnboardingPopUpIsActive: false,
      };
    case 'CLOSE_NOTIFICATION_BAR':
      return {
        ...state,
        notificationBarIsActive: false,
      };
    case 'OPEN_NOTIFICATION_BAR':
      return {
        ...state,
        notificationBarIsActive: true,
      };
    case 'SET_NOTIFICATION_BAR_HEIGHT':
      return {
        ...state,
        notificationBarHeight: action.payload,
      };
    default:
      return state;
  }
};
